import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from '../../../../components/ui/Select';
import Button from '../../../../components/ui/Button';
import Icon from '../../../../components/AppIcon';

interface FilterPanelProps {
  filters?: {
    status?: string;
    dateRange?: string;
    searchQuery?: string;
  };
  onFilterChange: (filterType: string, value: string) => void;
  onClearFilters: () => void;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  filters,
  onFilterChange,
  onClearFilters
}) => {
  const { t } = useTranslation();

  const statusOptions = [
    { value: 'all', label: t('performance.managerResponse.allStatus') },
    { value: 'pending', label: t('performance.managerResponse.pendingReview') },
    { value: 'reviewed', label: t('performance.managerResponse.responded') },
    { value: 'not_submitted', label: t('performance.managerResponse.notSubmitted') }
  ];

  const dateRangeOptions = [
    { value: 'all', label: t('performance.managerResponse.allTime') },
    { value: 'current', label: t('performance.managerResponse.currentMonth') },
    { value: 'last-month', label: t('performance.managerResponse.lastMonth') },
    { value: 'last-3-months', label: t('performance.managerResponse.last3Months') },
    { value: 'last-6-months', label: t('performance.managerResponse.last6Months') }
  ];

  const hasActiveFilters = (filters?.searchQuery?.trim() ?? '') !== '' ||
                          (filters?.dateRange && filters?.dateRange !== 'all');

  return (
    <div className="space-y-3">
      {/* Date Range Filter */}
      <Select
        options={dateRangeOptions}
        value={filters?.dateRange ?? 'all'}
        onChange={(val) => onFilterChange('dateRange', val as string)}
        placeholder={t('performance.managerResponse.timePeriod')}
      />

      {/* Search */}
      <div className="relative">
        <Icon
          name="Search"
          size={16}
          className="absolute start-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
        />
        <input
          type="text"
          placeholder={t('performance.managerResponse.searchPlaceholder')}
          value={filters?.searchQuery ?? ''}
          onChange={(e) => onFilterChange('searchQuery', e.target.value)}
          className="w-full ps-10 pe-4 py-2 border border-border rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary bg-background text-foreground text-sm"
        />
      </div>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <Button
          variant="outline"
          size="sm"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
          fullWidth
        >
          {t('performance.managerResponse.clearFilters')}
        </Button>
      )}
    </div>
  );
};

export default FilterPanel;